<template>
  <div id="parenttem">
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Outbound TMO Report
        <p class="pl-4">|</p>
      </h1>
      <vs-button
        size="small"
        v-if="btndis"
        color="success"
        type="filled"
        icon="add"
        @click="cusAdd"
        >Add</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis"
        >Delete</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        size="small"
        v-if="btndis3"
        color="#5b3cc4"
        type="filled"
        icon="check_circle_outline"
        @click="ressel"
        >Choose</vs-button
      >
    </div>

    <vx-card class="pb-4">
      <div class="columns">
        <div class="column is-narrow" style="width: 850px">
          <div class="columns">
            <div
              class="column is-narrow mt-2"
              style="width: 100px; text-align: right"
            >
              <span>ปลายทาง</span>
            </div>
            <div class="column is-narrow mt-2">
              <div style="width: 350px">
                <vs-select autocomplete v-model="pod" class="w-full -mt-2">
                  <vs-select-item
                    v-for="impc in importers"
                    :key="impc.code"
                    :value="impc.code"
                    :text="impc.code + '-' + impc.name"
                  />
                </vs-select>
              </div>
            </div>

            <div
              class="column is-narrow mt-3"
              style="width: 50px; text-align: right"
            >
              <span>ประเภท</span>
            </div>
            <div class="column is-narrow">
              <div style="width: 200px">
                <vs-select autocomplete v-model="tmotypes_code" class="w-full">
                  <vs-select-item
                    v-for="tmotype in tmotypes"
                    :key="tmotype.code"
                    :value="tmotype.code"
                    :text="tmotype.name"
                  />
                </vs-select>
              </div>
            </div>

            <div
              class="column is-narrow mt-3"
              style="width: 100px; text-align: right"
            >
              <span>From Date</span>
            </div>
            <div
              class="column is-narrow mt-2"
              style="width: 170px; text-align: right"
            >
              <!-- <datepicker format="yyyy-MM-dd" v-model="todate"></datepicker> -->
              <DatePicker
                v-model="fromDate"
                value-type="format"
                format="YYYY-MM-DD"
                :clearable="false"
                class="w-full"
              ></DatePicker>
            </div>
            <div
              class="column is-narrow mt-3"
              style="width: 100px; text-align: right"
            >
              <span>To Date</span>
            </div>
            <div
              class="column is-narrow mt-2 mr-4"
              style="width: 170px; text-align: right"
            >
              <!-- <datepicker format="yyyy-MM-dd" v-model="todate"></datepicker> -->
              <DatePicker
                v-model="toDate"
                value-type="format"
                format="YYYY-MM-DD"
                :clearable="false"
                class="w-full"
              ></DatePicker>
            </div>
            <div class="column mt-1" style="width: 170px; text-align: right">
              <vs-button
                class="mb-2"
                color="warning"
                icon="search"
                @click="onSubmit"
                >ค้นหา</vs-button
              >
            </div>
            <div v-if="btnshow" class="column mt-1" style="width: 170px">
              <vs-button
                class="mb-2"
                color="#5b3cc4"
                icon="description"
                @click="onReport"
                >Report</vs-button
              >
            </div>
            <div
              v-if="btnshow"
              class="column is-narrow mt-1"
              style="width: 120px"
            >
              <vs-button
                class="mb-2"
                color="success"
                icon="list"
                @click="onExcel"
                >Excel</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <transition-group
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <grid
        v-if="gridshow"
        :key="gridshow"
        :fromDate="fromDate"
        :toDate="toDate"
        :pod="pod"
        :tmotypes_code="tmotypes_code"
        class="pt-4"
      ></grid>
    </transition-group>

    <b-modal :active.sync="addshow" :width="1024" scroll="keep">
      <banksadd :acstate="acstate" :recid="recid" @grid="grid"></banksadd>
    </b-modal>
  </div>
</template>

<script>
import grid from "./grid";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
import pdfMake from "pdfmake";
import pdfFonts from "../../../../assets/custom-fonts";

export default {
  props: ["resback"],
  data() {
    return {
      inbfrom: "TMO_OUT",
      tmotypes_code: "",
      tmotypes: [],
      importers: [],
      pod: "",
      contents: [],
      btnshow: false,
      btnshow2: false,
      fromDate: "",
      toDate: "",
      title: "",
      btn_list: "",
      btn_choose: "",
      btn_add: "",
      btn_edit: "",
      btn_delete: "",
      ask_delete: "",
      del_complete: "",
      del_error: "",
      addshow: false,
      gridshow: false,
      btndis: false,
      btndis2: true,
      btndis3: true,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
    };
  },
  async created() {
    // console.log(this.lang_number);
    // console.log(this.resback);
    const formData = {
      searchval: "",
      inbfrom: this.inbfrom,
    };

    this.$store.dispatch("setReportGrid", 0);
    // this.gridshow = true;

    this.grid();
    if (typeof this.resback == "undefined") {
      this.btndis2 = true;
      this.btndis3 = false;
    } else {
      this.btndis2 = false;
      this.btndis3 = true;
    }

    try {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response3 = await axios.post(
        `${BASE_API_URL}/inbound-svc/customsports/getCustomsPorts`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response3.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response3.data.message,
        });
      } else {
        this.importers = response3.data;
      }

      const response4 = await axios.post(
        `${BASE_API_URL}/inbound-svc/tmotypes/getTmotypes`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
      } else {
        this.tmotypes = response4.data;
      }
    } catch (error) {
      this.data = [];
      this.total = 0;
      this.loading = false;
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // this.$router.replace("/pages/login/");
    }
  },
  watch: {},
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    onSubmit() {
      if (!this.toDate) {
        // console.log("NOO");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter To Date",
        });
      } else if (!this.fromDate) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter From Date",
        });
      } else {
        this.gridshow = true;
        this.btnshow = true;

        if (this.$store.state.reportgrid == 0) {
          this.$store.dispatch("setReportGrid", 1);
        } else {
          this.$store.dispatch("setReportGrid", 0);
        }
        // console.log(this.toDate);
      }
    },
    getArray(data) {
      // console.log(data);
      // console.log(data[0]);
      let arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        arData.push([
          {
            text: i,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: this.cvDate(item.out_at),
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.dclnumber,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: item.tmotypesCode,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: item.mawb,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: item.hawb,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: this.formatnumber(item.itempck) + " " + item.packagesCode,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.formatnumber(item.itemgw) + " " + item.gwunit,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: item.pol,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: item.pod,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
        ]);

        i++;
      });

      return arData;
    },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      this.daday = dd;
      this.damonth = mm;
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + yyyy;
    },
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    async onReport() {
      this.contents = [];

      if (!this.toDate) {
        // console.log("NOO");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter To Date",
        });
      } else if (!this.fromDate) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter From Date",
        });
      } else {
        // this.goDate();

        this.btndis = false;

        try {
          const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

          if (token) {
            const formData = {
              number: this.recid,
              fromDate: this.fromDate,
              toDate: this.toDate,
              pod: this.pod,
              tmotypes_code: this.tmotypes_code,
            };

            const response = await axios.post(
              `${BASE_API_URL}/report-svc/reports/outboundReportTmoPrintAll`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            // console.log(response.data.inborders.length);
            // console.log(response.data.inborders[0][0].polname);

            if (!response.data) {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data,
              });
            } else {
              for (let il = 0; il < response.data.exborders.length; il++) {
                this.contents.push([
                  {
                    text: "แนบท้ายประกาศกรมศุลกากรที่ ๑๑๕/๒๕๖๔",
                    fontSize: 16,
                    bold: true,
                    alignment: "right",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text: "รายงานการเคลื่อนย้ายของระหว่างพื้นที่คลังสินค้าและศูนย์บริการศุลกากรเพื่อกระจายสินค้า",
                    style: "title",
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text: "คลังสินค้า " + response.data.exborders[il][0].podname,
                    style: "title",
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text:
                      "ระหว่างวันที่......" +
                      new Date(this.fromDate).toLocaleDateString("th-TH") +
                      "......ถึงวันที่......" +
                      new Date(this.toDate).toLocaleDateString("th-TH") +
                      "......",
                    style: "title",
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text:
                      "ชื่อผู้ประกอบกิจการกระจายสินค้า____________________________________________",
                    fontSize: 16,
                    alignment: "left",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [0, 15, 0, 20],
                  },
                  {
                    text: response.data.exborders[il][0].ename ,
                    fontSize: 16,
                    alignment: "left",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [170, -40, 0, 0],
                  },
                  {
                    text:"เลขที่ประจำตัวผู้เสียภาษีอากร_________________________________________",
                    fontSize: 16,
                    alignment: "left",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [400, -20, 0, 0],
                  },
                  {
                    text: response.data.exborders[il][0].taxid,
                    fontSize: 16,
                    alignment: "left",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [550, -20, 0, 20],
                  },
                  {
                    table: {
                      // headers are automatically repeated if the table spans over multiple pages
                      // you can declare how many rows should be treated as headers
                      headerRows: 1,
                      widths: [30, 90, 90, 90, 70, 70, 70, 70, 60, 60], // 710
                      body: [
                        [
                          {
                            rowSpan: 2,
                            text: "ลำดับ",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {
                            rowSpan: 2,
                            text: "วัน-เวลา ที่เคลื่อนย้าย",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {
                            rowSpan: 2,
                            text:
                              "เลขที่ใบขนสินค้า" +
                              "\n" +
                              " ขาเข้า/ขาออก/ผ่านแดน",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {
                            rowSpan: 2,
                            text:
                              "ประเภทสินค้า" +
                              "\n" +
                              " (นำเข้า/ส่งออก/ผ่านแดน)",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {
                            colSpan: 2,
                            text: "เลขที่ใบตราส่งสินค้า",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {},
                          {
                            rowSpan: 2,
                            text: "จำนวนหีบห่อ/หน่วย",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {
                            rowSpan: 2,
                            text: "น้ำหนักรวม/หน่วย",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {
                            rowSpan: 2,
                            text: "ต้นทาง",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                          {
                            rowSpan: 2,
                            text: "ปลายทาง",
                            bold: true,
                            fontSize: 12,
                            alignment: "center",
                          },
                        ],
                        [
                          {},
                          {},
                          {},
                          {},
                          {
                            text: "MAWB",
                            bold: true,
                            fontSize: 12,
                            alignment: "right",
                          },
                          {
                            text: "HAWB",
                            bold: true,
                            fontSize: 12,
                            alignment: "right",
                          },
                          {},
                          {},
                          {},
                        ],
                      ],
                    },
                  },
                  {
                    table: {
                      heights: 15,
                      widths: [30, 90, 90, 90, 70, 70, 70, 70, 60, 60], // 710
                      body: this.getArray(response.data.exborders[il]),
                    },
                  },
                  {
                    // text: "ข้าพเจ้าขอรับรองว่ารายงานที่แสดงข้างต้นเป็นความจริงทุกประการ หากไม่ถูกต้องครบถ้วน ข้าพเจ้ายินยอมรับผิดชอบชดใช้ค่าเสียหายที่เกิดขึ้นกับกรมศุลกากร"+"\n"+"ไม่ว่าด้วยเหตุใด",
                    text: "ข้าพเจ้าขอรับรองว่ารายงานที่แสดงข้างต้นเป็นความจริงทุกประการ หากไม่ถูกต้องครบถ้วน ข้าพเจ้ายินยอมรับผิดชอบชดใช้ค่าเสียหายที่เกิดขึ้นกับกรมศุลกากร",
                    fontSize: 17,
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [60, 20, 0, 0],
                    pageBreak: "before",
                  },
                  {
                    text: "ไม่ว่าด้วยเหตุใด",
                    fontSize: 17,
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text: "ขอแสดงความนับถือ",
                    fontSize: 18,
                    alignment: "left",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [350, 20, 0, 10],
                  },
                  {
                    text: "ลงชื่อ……………………………",
                    fontSize: 18,
                    alignment: "left",
                    // [left, top, right, bottom]
                    margin: [450, 0, 0, 10],
                  },
                  {
                    text: "(……………………………………)",
                    fontSize: 18,
                    alignment: "left",
                    // [left, top, right, bottom]
                    margin: [450, 0, 0, 10],
                  },
                  {
                    text: "วันที่................................",
                    fontSize: 18,
                    alignment: "left",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    margin: [450, 0, 0, 10],
                  },
                  {
                    text: "ประทับตราบริษัท (ถ้ามี)",
                    fontSize: 18,
                    alignment: "left",
                    // [left, top, right, bottom]
                    // margin: [100, -20, 0, 0],
                    pageBreak: "after",
                    margin: [450, 0, 0, 10],
                  },
                ]);
              }

              const docDefinition = {
                // a string or { width: number, height: number }
                pageSize: "A4",

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: "landscape",

                content: this.contents,
                defaultStyle: {
                  // 4. default style 'THSarabunNew' font to test
                  font: "THSarabunNew",
                },
                styles: {
                  title: {
                    fontSize: 20,
                    bold: true,
                    alignment: "center",
                  },
                  header: {
                    fontSize: 18,
                    bold: true,
                    alignment: "right",
                    margin: [0, 190, 0, 80],
                  },
                  subheader: {
                    fontSize: 14,
                  },
                  superMargin: {
                    margin: [20, 0, 40, 0],
                    fontSize: 15,
                  },
                },
              };

              pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
              pdfMake.fonts = {
                // default Roboto font
                Roboto: {
                  normal: "Roboto-Regular.ttf",
                  bold: "Roboto-Medium.ttf",
                  italics: "Roboto-Italic.ttf",
                  bolditalics: "Roboto-MediumItalic.ttf",
                },
                // THSarabunNew Font
                THSarabunNew: {
                  normal: "THSarabunNew.ttf",
                  bold: "THSarabunNew Bold.ttf",
                  italics: "THSarabunNew italic.ttf",
                  bolditalics: "THSarabunNew Bolditalic.ttf",
                },
              };

              setTimeout(() => {
                pdfMake.createPdf(docDefinition).open();
              }, 2000);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Print Complete",
                text: "Print Complete",
              });
            }
          }
        } catch (error) {
          this.data = [];
          this.total = 0;
          this.loading = false;
          // throw error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    onExcel() {
      if (!this.toDate) {
        // console.log("NOO");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter To Date",
        });
      } else if (!this.fromDate) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Input Error",
          text: "Please Enter From Date",
        });
      } else {
        // if (this.$store.state.reportgrid == 0) {
        //   this.$store.dispatch("setReportGrid", 1);
        // } else {
        //   this.$store.dispatch("setReportGrid", 0);
        // }
        // console.log(this.toDate);
        let url = localStorage.getItem("appdb");
        let dbname = localStorage.getItem("dbname");
        let editor = localStorage.getItem("token");
        let comgroups_id = localStorage.getItem("comgroups_id");
        let userRole = localStorage.getItem("userRole");
        let pod = this.pod;
        let tmotypes_code = this.tmotypes_code;

        window.open(
          url +
            "api/ApiReportInboundTMOExport/" +
            this.fromDate +
            "/" +
            this.toDate +
            "/" +
            dbname +
            "/" +
            editor +
            "/" +
            comgroups_id +
            "/" +
            userRole +
            "/" +
            pod +
            "/" +
            tmotypes_code
        );
      }
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    ressel() {
      // console.log(this.recid);
      var vm = this;
      vm.$emit("gotres", this.recid);
    },
    // recsel(val) {
    //   // console.log(val);
    //   if (typeof this.resback == "undefined") {
    //     this.btndis = true;
    //     this.btndis3 = false;
    //     this.recid = val;
    //   } else {
    //     this.btndis = false;
    //     this.btndis3 = true;
    //     this.recid = val;
    //   }

    //   // console.log(val[1]);
    // },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.btndis = false;
      this.acstate = "ADD";
      // this.$store.dispatch("setCompanysTypesGrid", 1);
    },
    grid() {
      this.addshow = false;
      this.btndis = false;
    },
    cusEdit() {
      this.addshow = true;
      this.btndis = false;
      this.acstate = "EDIT";
      // this.$store.dispatch("setCompanysTypesGrid", 1);
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: this.ask_delete + " " + this.recid,
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      this.btndis = false;
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        code: this.recid,
      };
      axios
        .post("/ApiDelBanks", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: this.del_error,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: this.del_complete,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Deleted Error",
            text: err,
          });
        });

      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  components: {
    grid,
    // banksadd
    DatePicker,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
